// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".test-badge[data-v-2ed9c3a6]{font-family:\"Inter\";font-size:14px;font-weight:500;line-height:16px;font-weight:700;color:#283651;cursor:pointer;display:flex;background-color:#f1f5fc;padding:8px 12px;grid-gap:10px;gap:10px}.test-badge.rounded[data-v-2ed9c3a6]{border-radius:40px}.test-badge.warning[data-v-2ed9c3a6]{background-color:#f5dc9d}.test-badge.error[data-v-2ed9c3a6]{background-color:#f1998e}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
